<template>
  <div>
    <v-container class="app-breadcrumbs-container">
      <v-breadcrumbs class="app-breadcrumbs" :items="breadcrumbs">
        <v-icon slot="divider">chevron_right</v-icon>
        <template slot="item" slot-scope="props">
          <router-link
            :to="props.item.to"
            :class="[
              props.item.disabled && 'v-breadcrumbs__item--disabled',
              'app-breadcrumbs__item'
            ]"
          >
            {{ props.item.text }}
          </router-link>
        </template>
      </v-breadcrumbs>
    </v-container>
    <div class="main-title">
      <v-container fill-height>
        <v-layout align-center>
          {{ $t("reset.title") }}
        </v-layout>
      </v-container>
    </div>
    <v-container class="lost-container">
      <v-layout>
        <v-flex>
          <div>
            {{ $t("reset.tip") }}
          </div>
        </v-flex>
      </v-layout>

      <v-form ref="form">
        <v-container>
          <v-layout>
            <v-flex xs12>
              <v-text-field
                v-model="email"
                ref="email"
                :rules="nameRules"
                validate-on-blur
                :label="$t('reset.email')"
                required
                clearable
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <v-layout column>
        <v-flex>
          <button class="button shadow" @click="submit">
            {{ $t("reset.forget") }}
          </button>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="sendTip" max-width="500px">
      <v-card>
        <v-card-title>
          <span>{{ tip }}</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-actions>
          <v-btn color="primary" flat @click="gotoLogin">
            {{ $t("common.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import account from "@/api/account";

const SECONDS = 6;

export default {
  data() {
    return {
      email: "",
      nameRules: [value => !!value || this.$t("login.rules")],
      isGettingCode: false,
      second: SECONDS,
      sendTip: false,
      tip: this.$t("password.pwd_same"),
      isSuccess: false
    };
  },

  computed: {
    form() {
      return {
        email: this.email
      };
    },
    breadcrumbs() {
      return [
        {
          to: { name: "home" },
          disabled: false,
          text: this.$t("breadcrumbs.home")
        },
        {
          to: { name: "account/info" },
          disabled: false,
          text: this.$t("breadcrumbs.account")
        },
        {
          to: { name: "reset-password" },
          disabled: true,
          text: this.$t("breadcrumbs.password_edit")
        }
      ];
    },
    breakpoint() {
      return this.$vuetify.breakpoint;
    }
  },

  methods: {
    ...mapMutations(["logout"]),
    submit() {
      if (this.form.email) {
        this.sendEmail();
      }
    },

    async sendEmail() {
      try {
        const res = await account.sendEmail({ ...this.form, from: 2 });
        if (!res.data.isError) {
          this.tip = this.$t("reset.success");
          this.sendTip = true;
          this.isSuccess = true;
        } else {
          this.tip = res.data.msg;
          this.sendTip = true;
          this.isSuccess = false;
        }
      } catch (e) {
        this.tip = e.response.data.msg;
        this.sendTip = true;
        this.isSuccess = false;
      }
    },

    gotoLogin() {
      this.sendTip = false;
      if (this.isSuccess) {
        this.$router.push({ name: "login" });
      }
    }
  }
};
</script>

<style scoped lang="sass" src="./reset-password.sass"></style>
